export const namespace = 'feathers';
